<template>
  <div>
    <div class="servebanner">
      <div class="funcontMain" @click="callServeClick('https://hztk5.kuaishang.cn/bs/im.htm?cas=68109___303309&fi=77664')">
        <div class="funmainpic">
          <img src="static/img/serveicon/call.png" alt="">
        </div>
        <p >联系客服</p>
      </div>
      <div class="funcontMain" @click="opinionClick()">
        <div class="funmainpic">
          <img src="static/img/serveicon/opinion.png" alt="">
        </div>
        <p>商务合作</p>
      </div>
      <div class="funcontMain" v-show="backTop" @click="backTopFun()">
        <div class="funmainpic">
          <img src="static/img/serveicon/gotop.png" alt="">
        </div>
        <p>返回顶部</p>
      </div>
    </div>
    <!-- 意见建议 -->
    <div class="opinBanner">
      <el-dialog title="商务合作" :visible.sync="opinionVisible" >
        <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left
        ">
          <el-form-item label="联系方式"  prop="contact">
            <el-input v-model.trim="form.contact" placeholder="请留下您的联系方式，我们会及时联系您"></el-input>
          </el-form-item>
          <el-form-item label="诉求" prop="title">
            <el-input v-model.trim="form.title" placeholder="请简单描述您的诉求"></el-input>
          </el-form-item>
          <el-form-item label="合作需求" prop="desc">
            <el-input type="textarea"  maxlength="500" show-word-limit :rows="4" v-model.trim="form.desc" placeholder="详细描述您想要合作的产品及需求痛点"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :disabled="disabled" :type="type" class="subbtn" @click="onSubmit('form')">
              <span v-if="loding" class="el-icon-loading"></span>
              发送
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
 
</template>

<script>
export default {
  name: 'App',
  data:function(){
    return {
      disabled:false,
      type:"primary",
      labelPosition: 'right',
      loding:false,
      callusVisible:false,//联系我们弹框
      opinionVisible: false,//意见建议弹框
      backTop: false,//返回顶部
      form: {
        title: "",
        contact:"",
        desc: "",
        // fileList:[],
      },
      rules: { // 表单验证规则
        contact:[
          {required: true, message: '联系方式不能为空', trigger: 'blur' },
        ],
        title: [
          {required: true, message: '诉求不能为空', trigger: 'blur' },
          {min: 2, max: 15, message: '只能使用中文，限制2至15字', trigger: 'blur'},
        ],
        desc:[
          { required: true, message: '请填写合作需求', trigger: 'blur' },
        ]
      },
    }
  },
  mounted() {
    this.scrollWindow();
  },
  methods: {
    // 提交
    onSubmit(formName) {
      var that = this;
      if(this.disabled){
        return;
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loding = true;
          that.disabled = true;
          $.ajax({
          url: 'https://activityManual.epaynfc.com/sendEmail',
          data: { 
            subject: that.form.title,
            tableText:that.form.desc,
            phone: that.form.contact 
          },
          dataType: 'jsonp'
          })
          window.callBack = function (obj) {
            that.loding = false;
            if(obj.respCode == 1){
              that.$message.success("非常感谢您的留言，我方商务人员会及时联系您")
              that.opinionVisible = false;
              that.form.title = '';
              that.form.desc = '';
              that.form.contact = '';
              that.disabled = false;
            }else{
              that.opinionVisible = false;
              that.form.title = '';
              that.form.desc = '';
              that.form.contact = '';
              that.disabled = false;
            }
          };
        } else {
          // that.opinionVisible = false;
          return false;
        }
      })
      
    },
    //联系我们
    callServeClick(m){
      window.open(m);
      // this.callusVisible = true;
    },
    //意见建议
    opinionClick(){
      this.opinionVisible = true;
      this.form.title = '';
      this.form.desc = '';
      this.form.contact = '';
    },
      backTopFun() {
        $("html, body").animate({ scrollTop: "0" }, 1000);
      },
      scrollWindow() {
        var that = this;
        $(window).scroll(function() {
          var $w = $(this),
            st = $w.scrollTop();
          if (st > 200) {
            that.backTop = true;
          } else {
            that.backTop = false;
          }
        });
      },
  },
  watch:{
  
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/css/publicsty";
</style>
  


// WEBPACK FOOTER //
// src/components/serveAopinion .vue